import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { BrandService } from '../../../business-services/brand.service';
import { AddBrandComponent } from '../add-brand/add-brand/add-brand.component';
import { EditBrandComponent } from '../edit-brand/edit-brand/edit-brand.component';
import { Features } from '../../../business-entities/user-role-view-model';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.css']
})
export class BrandComponent implements OnInit {

  brandList: BrandViewModel[];
  competenceList: BrandViewModel[];
  popupCloseResult = false;
  total$: Observable<number>;
  paginationSub: Subscription;
  focus$ = new Subject<string>();
  userRoleRightsDetails: UserRoleMenu;
  isDealerLoggedIn: boolean;
  features: Features[] = [];
  subscription : Subscription;
  isAddBrand:boolean = false;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private brandService: BrandService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    public pService: CustomPaggerService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private userService: UserDataService,
    private currentLanguageService: CurrentLanguage,
    private secureStorage: SecureStorage,
    config: NgbModalConfig
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brandCode', 'brandName', 'isActive'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }
  ngOnInit(): void {
    this.pService.dataSource = [];
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Brand);
    this.getFeatures();
    this.getBrandList();
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features == null || this.features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        this.features = res;
        this.updateFeatureFlagValue();
      })
    }
   this.updateFeatureFlagValue();
  }

  updateFeatureFlagValue()
  {
    if (this.features?.length > 0) {
      this.isAddBrand = this.features.find(x => x.featureCode === Enums.FeatureCode.AddBrands)?.isActive;
    }
  }

  getBrandList() {
    this.spinner.show();
    this.brandService.getBrand().then(response => {
      if (response) {
        this.pService.dataSource = response;
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.brandList = this.BransDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      } else if (
        response.responseObject &&
        response.responseObject.errorCount > 0
      ) {
        if (
          response.responseObject.result &&
          response.responseObject.result.errorCode ===
          Enums.ErrorCodes.ServiceCategoriesCode
        ) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  private BransDataMapper(brandList: any) {
    let supperArray = [];
    if (brandList && brandList.length > 0) {
      for (let index = 0; index < brandList.length; index++) {
        const element = brandList[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.image = element.image;
        single.isActive = element.isActive;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  onAdd() {
    const modalref = this.modalService.open(AddBrandComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  deleteBrand(id: number) {
    this.spinner.show();
    this.brandService.GetCompetenceByBrandId(id).then(response => {
      this.spinner.hide();
      this.brandResponse(id, response);
    });
  }
  
  brandResponse(id: number, response: any) {
    if (response) {
      const hasCompetence = response.competenceByBrand.length > 0;
      const modelBodymsg = hasCompetence
        ? this.translate.instant('lblSureToDeleteBrandCompetence')
        : Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblBrand"), false);
      const modelHeadermsg = this.translate.instant('lblDelete');
  
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then(
        _result => {},
        reason => {
          this.popupCloseResult = this.getDismissReason(reason);
          if (this.popupCloseResult) {
            this.brandDeletion(id);
          }
        }
      );
    } else if (response.responseObject?.errorCount > 0) {
      if (response.responseObject.result?.errorCode === Enums.ErrorCodes.ServiceCategoriesCode) {
        this.spinner.hide();
      }
    }
  }
  
  brandDeletion(id: number) {
    this.brandService.DeleteBrand(id).then(response => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        const deletedmsg = this.translate.instant('lblDeletedBrand');
        this.toastr.success(deletedmsg);
        this.getBrandList();
      } else if (response.responseCode === Constant.ValidationFailure) {
        const deletedmsg = this.translate.instant('lblBrandNotDeleted');
        this.toastr.error(deletedmsg);
      }
    });
  }
  
  onEdit(brand: any) {
    this.brandService.brandId = brand.id;
    const modalref = this.modalService.open(EditBrandComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  /**
    * Methid to generate auto row number based on per page size
    * @param cIndex
    */
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    } else if (this.pService.page > 1) {
      rtPageNumber =
        Number.parseInt(
          `${this.pService.pageSize * (this.pService.page - 1)}`
        ) +
        (cIndex + 1);
    }

    return rtPageNumber;
  }

}
